import React, { useCallback } from 'react'
import classNames from 'classnames'

import { Button } from 'pharmacy/src/input/button'

import css from './headerRegisterButton.scss'

export const HeaderRegisterButton = ({ pathname }) => {
  const handleRegisterClick = useCallback(
    (e) => {
      e.preventDefault()

      // Preserve existing query params (utm_campaign, invitecode, from, etc.)
      const params = new URLSearchParams(window.location.search)

      // Add/override with new params
      params.set('src', pathname.replace(/^\/+/, '') || 'public_home')
      params.set('src_path', pathname)
      params.set('src_item', 'header')

      // Always go to /register - PHP will redirect to V2 if needed
      window.location.href = `/register?${params}`
    },
    [pathname]
  )

  return (
    <>
      <Button
        type="dark_blue"
        className={classNames(css.button, css.displayForLargeScreen)}
        onClick={handleRegisterClick}
      >
        <div className={css.buttonText}>Register</div>
      </Button>
      <Button
        type="orange"
        className={classNames(css.button, css.displayForSmallScreen)}
        onClick={handleRegisterClick}
      >
        <div className={css.buttonText}>Register</div>
      </Button>
    </>
  )
}
